import script from "./middle-wrap.vue?vue&type=script&lang=ts&setup=true"
export * from "./middle-wrap.vue?vue&type=script&lang=ts&setup=true"

import "./middle-wrap.vue?vue&type=style&index=0&id=d7370694&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7370694"]])

export default __exports__